import { Card, CircularProgress, Stack, Typography, useTheme } from '@mui/material';
import React from 'react'

export default function CodeExecutionBanner(): React.ReactElement {
  const theme = useTheme();

  return <Card sx={{ p: 2, width: '100%' }}>
    <Stack direction='row' spacing={1} justifyContent='center' display='flex'>
      <CircularProgress />
      <Typography>Waiting for code execution...</Typography>
    </Stack>
  </Card>
}
